import _typeof from "@babel/runtime/helpers/esm/typeof";
import { defineComponent as _defineComponent } from 'vue';
import { SImageLazy } from '@strana-artw/ui-kit';
import { computed, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PlanOutput',
  props: {
    input: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  emits: ["error"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    function getImageUrl(payload) {
      if (!payload) {
        return null;
      }
      if (_typeof(payload) === 'object') {
        var _payload$aws;
        return (_payload$aws = payload.aws) !== null && _payload$aws !== void 0 ? _payload$aws : null;
      }
      return payload;
    }
    var plan = computed(function () {
      var _props$input;
      var _ref2 = (_props$input = props.input) !== null && _props$input !== void 0 ? _props$input : {},
        p = _ref2.plan,
        pPng = _ref2.plan_png,
        planPng = _ref2.planPng;
      return getImageUrl(p) || getImageUrl(pPng) || getImageUrl(planPng) || '';
    });
    watch(plan, function (value) {
      if (!value) {
        emit('error', true);
      }
    }, {
      immediate: true
    });
    function errorHandler(event) {
      event.target.src = '';
      emit('error', true);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      getImageUrl: getImageUrl,
      plan: plan,
      errorHandler: errorHandler,
      SImageLazy: SImageLazy
    };
  }
});